<template>
    <div>
        <Modal v-model="modelShow" title="计价模型列表" width="900">
            <Form :model="queryParams" inline :label-width="100">
                <FormItem label="计价模型名称">
                    <Input v-model="queryParams.name" placeholder="计价模型名称" clearable />
                </FormItem>
                <FormItem label="模式类型">
                    <dict-select namespace="default" id="billingModel" :exclusion="[]" v-model="queryParams.modelId" />
                </FormItem>
                <Button type="primary" style="margin-left:10px" @click="query">查询</Button>
            </Form>
            <data-grid ref="lg" :columns="cols" :queryParams="queryParams" :queryUrl="queryUrl" paramsName="params" subListName :dataList="[]">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small" highlight-row @on-current-change="onCurrentChange" style="margin:10px"></Table>
                </template>
            </data-grid>
            <div slot="footer">
                <Button type="primary" @click="submit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'
import dataGrid from '@/components/datagrid.vue'
import dictSelect from '@/components/select/dict-select.vue'
export default {
    components: { tableTitle, dataGrid, dictSelect },
    data() {
        return {
            modelShow: false,
            queryUrl: "CORE-CONTRACT/messageService/queryService/queryBillingModelListByParam",
            queryParams: {
                name: "",
                modelId: "",
            },
            currentRows: {},
            cols: [
                { title: '计价模型编号', key: 'id', width: 100 },
                { title: '计价模型名称', key: 'name' },
                { title: '模式类型', key: 'modelId', dict: ['default', 'billingModel', true] },
                { title: '租期', key: 'rentTerm' },
                { title: '免租天数', key: 'noBillingTerm' },
                { title: '创建者', key: 'inputUser' },
                { title: '打包租金', key: 'packageRental' },
                { title: '打包服务费', key: 'packageService' },
                { title: '超期租金', key: 'overdueRental' },
                { title: '超期服务费', key: 'overdueService' },
            ]
        }
    },
    methods: {
        openModal() {
            this.modelShow = true
        },
        query() {
            this.$refs['lg'].loadFirstPage()
        },
        onCurrentChange(currentRow) {
            this.currentRows = currentRow
        },
        submit() {
            if (JSON.stringify(this.currentRows)!="{}") {
                this.$emit('onChild', this.currentRows)
                this.modelShow = false
            }else{
                this.$Message.warning('请选择计费模型ID')
            }

        }
    }

}
</script>

<style lang="scss" scoped>
</style>